import { Spinner } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OfferPreviewLoading.css';
import { ETestId } from '../../../../../common/constants/testId';

export const OfferPreviewLoading = () => {
  return (
    <div data-testid={ETestId.OfferPreviewLoading} className={styles['root']}>
      <Spinner size={24} />
    </div>
  );
};
